export default __webpack_public_path__ + "static/media/ScuMentalHealthConnect.5c59a9d7.png";